import { render, staticRenderFns } from "./EfsMdChickenPriceList.vue?vue&type=template&id=52ef065b&scoped=true&"
import script from "./EfsMdChickenPriceList.vue?vue&type=script&lang=js&"
export * from "./EfsMdChickenPriceList.vue?vue&type=script&lang=js&"
import style0 from "./EfsMdChickenPriceList.vue?vue&type=style&index=0&id=52ef065b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef065b",
  null
  
)

export default component.exports